<template>
    <div
        v-if="loaded && session"
        class="game-responsive"
        :class="{
            responsive_10x16: !isIgsGame && !isNeGame && !isIbGame && gameId !== 'aviator' && gameId !== 'jet',
            responsive_3x4: isIgsGame,
            responsive_9x16: isNeGame || isIbGame || gameId === 'aviator' || gameId === 'jet'
        }"
    >
        <redpipe-frame :session="loaded ? session : null" />
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

import RedpipeFrame from '../../../common/redpipe/redpipe-frame.vue';

export default {
    name: 'game-redpipe',
    components: { RedpipeFrame },
    props: {
        gameId: {
            type: String,
            required: true
        },
        backUrl: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            loaded: false,
            isMobile: isMobile.phone || isMobile.tablet,
            isIgsGame: false,
            isNeGame: false,
            isIbGame: false
        };
    },
    computed: {
        isLoggedIn() {
            return Vue.state.player.isLoggedIn();
        },
        lang() {
            return Vue.state.lang.currentLang;
        },
        session() {
            return Vue.state.redpipe.session.get();
        }
    },
    watch: {
        async $route() {
            await this.load();
        }
    },
    async created() {
        await Vue.state.player.ensure();
        await this.load();
    },
    methods: {
        async load() {
            this.loaded = false;

            if (this.isLoggedIn) {
                await Vue.state.redpipe.session.open(this.gameId, this.lang, this.backUrl);
            } else {
                await Vue.state.redpipe.session.openDemo(this.gameId, this.lang, this.backUrl);
            }

            if (this.isMobile) window.location.replace(this.session.gameMobileUrl || this.session.gameDesktopUrl);

            this.isIgsGame = this.session.gameDesktopUrl.indexOf('/is/') > 0;
            this.isNeGame = this.session.gameDesktopUrl.indexOf('/ne/') > 0;
            this.isIbGame = this.session.gameDesktopUrl.indexOf('/ib/') > 0;

            this.loaded = true;
        }
    },
    beforeDestroy() {
        this.loaded = false;
    }
};
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/game/game-redpipe.vue